if (!customElements.get('banner-video')) {
  class BannerVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.toggle = this.querySelector('[data-video-toggle]');
      this.autoplay = this.video.hasAttribute('autoplay');
      this._holdPlayback = false;
      this._blocked = false;
      this._observerPaused = false;
      this._controller = new AbortController();
      this._reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._applyMotionPreference = this._applyMotionPreference.bind(this);
      this._syncToggle = this._syncToggle.bind(this);
      this._handleToggle = this._handleToggle.bind(this);

      const { signal } = this._controller;

      if (this.autoplay) this.video.muted = true;

      ['play', 'pause', 'ended'].forEach(type => this.video.addEventListener(type, this._syncToggle, { signal }));
      this.toggle?.addEventListener('click', this._handleToggle, { signal });
      this._reducedMotionQuery.addEventListener('change', this._applyMotionPreference, { signal });

      this._applyMotionPreference();
      this._syncToggle();

      this._observer = new IntersectionObserver(([entry]) => {
        if (entry.intersectionRatio === 0) {
          if (!this.video.paused) {
            this._observerPaused = true;
            this.video.pause();
          }
        } else if (this._observerPaused && !this._holdPlayback && !this._reducedMotionQuery.matches) {
          this._observerPaused = false;
          this._play();
        }
      });
      this._observer.observe(this.video);
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
    }

    _play() {
      this.video.play()?.catch(error => {
        if (error.name !== 'NotAllowedError') return;
        this._holdPlayback = true;
        this._blocked = true;
        this._syncToggle();
      });
    }

    _handleToggle() {
      this._observerPaused = false;
      if (this.video.paused || this.video.ended) {
        this._holdPlayback = false;
        this._play();
      } else {
        this._holdPlayback = true;
        this.video.pause();
      }
    }

    _syncToggle() {
      if (!this.toggle) return;
      const playing = !this.video.paused && !this.video.ended;
      this.toggle.dataset.state = playing ? 'playing' : 'paused';
      this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
      this.toggle.hidden =
        this.toggle.hasAttribute('data-optional') && !this._blocked && !this._reducedMotionQuery.matches;
    }

    _applyMotionPreference() {
      if (this._reducedMotionQuery.matches) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
      } else if (this.autoplay && this.video.paused && !this._holdPlayback) {
        this.video.setAttribute('autoplay', '');
        this._play();
      }
      this._syncToggle();
    }
  }

  customElements.define('banner-video', BannerVideo);
}
